import { Language } from '../../types';
var languages = [Language.En, Language.He];
export default languages;
//# sourceMappingURL=languages.js.map